import { Injectable, inject } from '@angular/core';
import { cloneFilterState } from './data-filter.service';
import { applyFilterDateRange } from '../shared/date-filter.util';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { MedsOfInterestFilter, MedsOfInterestResponse } from '../models/medication-group';
import {
  ComplianceWindow,
  DEFAULT_COMPLIANCE_WINDOW,
  StockAreaFilter,
  StockAreaApiResponse,
  StockAreaConfigUpdateRow
} from '../models/stock-area-config';

@Injectable({
  providedIn: 'root'
})
export class NursingAuditService {
  private http = inject(HttpClient);
  private authService = inject(AuthService);

  selectedConfiguration:any = {};


  getNursingAuditData(days: any) {
    return this.http.get(environment.apiUrl + "audit_data?days=" + days);
  }

  getIndvActComments(key: any, adminId: any, maapKey: any, recordid: any) {
    return this.http.get(environment.apiUrl + 'discrepancy_status?key=' + key+'&adminId='+adminId+'&maapKey='+maapKey+"&id="+recordid);
  }

  submitDescripencyStatus(id: any, comment: any, resolutionCoding: any, key: any,transType: any, practiceIssue: any) {
    return this.http.post(environment.apiUrl + 'discrepancy_status', { "comment": comment, "status": resolutionCoding, "discrepancy": id, "key":key,'transType':transType , 'practiceIssue':practiceIssue});
  }

  submitFollowUp(id: any, status: any) {
    return this.http.post(environment.apiUrl + 'audit_followup', { "status": status, "audit_2": id });
  }

  loadAuditDeviations(adminids: any, days: any) {
    return this.http.post(environment.apiUrl + 'audit/deviations', {admins:adminids, days:days});
  }

  getFollowUps(rowid: any) {
    return this.http.get(environment.apiUrl + 'audit_followup?audit_2=' + rowid);
  }

  getComments(data: any) {
    return this.http.get(environment.apiUrl + `audit_status?location=All&lanId=${data["lanId"]}`);
  }
  getFollowUpHistory(data: any){
    return this.http.get(environment.apiUrl + 'all/follow_up/history?lanId='+data['lanId']);
  }

  getHistoryData(filter: any) {
    const filterString = this.generateQueryStringFromObject(filter);
    return this.http.get(environment.apiUrl + 'all/history/data?' + filterString);
  }

  submitComment(employeeName: any, lanId: any, loc: any, comment: any, status: any, _id: any, days: any, prevFollowUp: any, taggedUsers: any, locGroup: any, adminGroup: any, varianceComment=false, followUpChanged=false) {
    return this.http.post(environment.apiUrl + 'audit/comment/create',
      {
        "comment": comment,
        "followUp": status,
        "employeeName": employeeName,
        "lanId":lanId,
        "location": "All",
        "audit":_id,
        "days":days,
        "prevFollowUp":prevFollowUp,
        "taggedUsers":taggedUsers,
        'locGroup':locGroup,
        'adminGroup':adminGroup,
        'varianceComment': varianceComment,
        'followUpChanged': followUpChanged
      });
  }

  loadFilters(filter: any = null){
    filter = cloneFilterState(filter || {});
    if(filter['facilityId'] == 'All') {
      delete filter.facilityId;
    }
    if(filter['campusId'] == 'All'){
      delete filter.campusId;
    }
    if(filter['regionId'] == 'All'){
      delete filter.regionId;
    }
    if(filter['serviceGroup'] == 'All'){
      delete filter.serviceGroup;
    }
    filter.analyticsRequest = "true";
    const filterString = this.generateQueryStringFromObject(filter);
    return this.http.get(environment.apiUrl +"audit/filter/options?"+filterString)
  }

  getAuditPagedData(skip: any, limit: any, filter: any){
    filter = cloneFilterState(filter || {});
    const filterString = this.generateQueryStringFromObject(applyFilterDateRange(filter));
    return this.http.get(environment.apiUrl+'audit_data_2?$skip='+skip+'&'+filterString)
    // '&$limit=' + 10 +
  }

  getAuditPagedDataParent(skip: any, limit: any, filter: any, adminId=null){
    filter = cloneFilterState(filter || {});
    if (Array.isArray(filter.adminName)) {
      // User names can contain commas, so preserve the selected values as a
      // structured array instead of relying on ambiguous comma delimiters.
      if (filter.adminName.length) {
        filter.adminName = JSON.stringify(filter.adminName);
      } else {
        delete filter.adminName;
      }
    }
    if(filter['regionId'] == 'All' || !(filter['regionId'])){
      delete filter.regionId;
    }
    if(filter['campusId'] == 'All' || !(filter['campusId'])){
      delete filter.campusId;
    }
    if(filter['facilityId'] == 'All' || !(filter['facilityId'])) {
      delete filter.facilityId;
    }
    if(filter['locationGroupId'] && filter['locationGroupId'].length === 1 && filter['locationGroupId'][0] === 'All') {
      delete filter.locationGroupId;
    }
    if(filter['serviceGroup'] == 'All'){
      delete filter.serviceGroup;
    }

    let filterString = this.generateQueryStringFromObject(filter);
    if(adminId!= null){
      skip = 0;
      filterString += '&globalSearch='+ adminId;
    }
    
    return this.http.get(environment.apiUrl+'audit/parent?$skip='+skip+'&'+filterString);
  }
  
  getAuditDataChildrens(node: any){
    // var filterString = this.generateQueryStringFromObject(filter);
    const adminId = node['data']['lanId'];
    const locationGrouping = node['data']['locationGrouping'];
    const transactionStartDate = node['data']['transactionStartDate'];
    const transactionEndDate = node['data']['transactionEndDate'];
    let url = environment.apiUrl+'audit/childrens?adminId='+adminId+'&locationGrouping='+locationGrouping+'&transactionStartDate='+transactionStartDate+'&transactionEndDate='+transactionEndDate
    if(node.data.subParent){
      url = url+"&type=subparent"
    }
    if(node.data.locationGrouping == "MULTIPLE")
    {
      url = url+"&type=multiple"
    }
    
    return this.http.get(url)
  }

  tryClearWhitespaceFromGlobalSearch(params: any)
  {
    if(params.globalSearch)
    {
      const textToTrim: string = params.globalSearch;
      params.globalSearch = textToTrim.trim();
    }
  }

  generateQueryStringFromObject(params: any){
    params = cloneFilterState(params || {});
    this.tryClearWhitespaceFromGlobalSearch(params);
    return Object.keys(params).map(key => {
      // Properly encode both key and value to handle special characters
      const encodedKey = encodeURIComponent(key);
      const encodedValue = encodeURIComponent(params[key]);
      return `${encodedKey}=${encodedValue}`;
    }).join('&');
  }

  updateOverrideRule(row: any) {
    return this.http.post(environment.apiUrl + 'update/audit/override',{id:row["_id"]});
  }

  getOverideData(skip: any, filter: any) {
    const filterString = this.generateQueryStringFromObject(filter);
    return this.http.get(environment.apiUrl + 'fetch/audit/overriderules?$sort=-createdAt&$skip=' + skip + '&$limit=10&'+filterString)
  }

  getOverideRawConfiguration(id: any){
    return this.http.get(environment.apiUrl + 'get/audit/override/configuration/'+id)
  }

  fetchMeds() {
    return this.http.get(environment.apiUrl + 'fetch/meds');
  }

  fetchLocations() {
    return this.http.get(environment.apiUrl + 'fetch/locations');
  }

  createOvrride(data: any) {
    data["witnesstoken"] = this.authService.getWitnessToken()
    return this.http.post(environment.apiUrl + "add/audit/override", data)
  }

  createFavorite(data: any) {
    return this.http.post(environment.apiUrl + "audit/favorite/create", data)
  }

  fetchAdminTypes(){
    return this.http.get(environment.apiUrl + 'fetch/admin/types');
  }

  searchAutoComplete(field: any, text: any, filter: any = null){
    const filterString = this.generateQueryStringFromObject(filter);
    return this.http.get<string[]>(environment.apiUrl+'autocomplete/search?field='+field+'&text='+text+'&'+filterString).pipe(
      map(values => field === 'adminid'
        ? values.filter(value => !/^\*+SYSTEM\*+$/i.test(value.trim().replace(/&#(?:x4d|77);/gi, 'M')))
        : values)
    );
  }

  loadRiskTrending(row: any){
    const locationGrouping = (row["locationGroupingString"] || '').replace(/&/g, '[[AND]]');
    return this.http.get(environment.apiUrl+'trendingrisk/info?lanId='+row['lanId']+'&locationGrouping='+locationGrouping+'&serviceGroup='+row['serviceGroup'])
  }

  private buildEncodedUrl(baseUrl: string, params: Record<string, any>): string {
    const queryString = Object.keys(params)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
      .join('&');
    return `${baseUrl}?${queryString}`;
  }

  loadRiskScoringHistory(row: any){
    const params = {
      bedDev: '',
      serviceGroup: row["serviceGroup"],
      locationGrouping: row["locationGroupingString"],
      lanId: row["lanId"],
      days: row["duration"]
    };

    if (row.history) {
      (params as any)['history'] = 'true';
      (params as any)['auditDate'] = row["auditDate"];
    }

    const url = this.buildEncodedUrl(environment.apiUrl + 'riskscore/info', params);
    return this.http.get(url);
  }
  loadMaapRiskScoreLocation(row: any){
    return this.http.get(environment.apiUrl + 'maap/riskscore/all-locations?lanId='+row['lanId']);
  }

  generatePdf(data: any, sharableUrl: any){
    return this.http.post(environment.apiUrl+'generate/pdf',{"data":data,"sharableUrl":sharableUrl}, { responseType: 'json' });
  }

  getChartByRisk(filter: any){
    const filterString = this.generateQueryStringFromObject(filter);
    return this.http.get(environment.apiUrl+'audit-summary/chart-by-risk?' + filterString)
  }

  getHighRiskByLocation(filter: any){
    const filterString = this.generateQueryStringFromObject(filter);
    return this.http.get(environment.apiUrl+'audit-summary/high-risk-by-loc?' + filterString)
  }
  
  getHighRiskByAdmin(filter: any){
    const filterString = this.generateQueryStringFromObject(filter);
    return this.http.get(environment.apiUrl+'audit-summary/high-risk-by-admin?' + filterString)
  }

  getHighRiskResSummary(filter: any){
    filter = cloneFilterState(filter || {});
    filter.duration=90;
    const filterString = this.generateQueryStringFromObject(applyFilterDateRange(filter));
    return this.http.get(environment.apiUrl+'audit-summary/high-risk-res-summary?' + filterString)
  }

  getPainScoreData(filter: any){
    filter = cloneFilterState(filter || {});
    filter.duration=90;
    const filterString = this.generateQueryStringFromObject(filter);
    return this.http.get(environment.apiUrl+'get/pain-scores?' + filterString)
  }
  getOverViews(filter: any){
    const filterString = this.generateQueryStringFromObject(applyFilterDateRange(filter || {}));
    return this.http.get(environment.apiUrl+'get/highRiskDescrep/totalInteraction?' + filterString)
  }
  getadcEhrOverViews(filter: any){
    const filterString = this.generateQueryStringFromObject(applyFilterDateRange(filter || {}));
    return this.http.get(environment.apiUrl+'get/adc/ehr/overViews?' + filterString)
  }
  getverifiedOverViews(filter: any){
    const filterString = this.generateQueryStringFromObject(applyFilterDateRange(filter || {}));
    return this.http.get(environment.apiUrl+'get/verified/overViews?' + filterString)
  }
  getUnaccountedMedData(filter: any){
    const filterString = this.generateQueryStringFromObject(applyFilterDateRange(filter || {}));
    return this.http.get(environment.apiUrl+'get/unaccounted/med/overView?' + filterString)
  }
  getExecutiveDash(filter: any){
    const filterString = this.generateQueryStringFromObject(applyFilterDateRange(filter || {}));
    return this.http.get(environment.apiUrl+'get/executive/dash?' + filterString)
  }
  getAuditorFollowUp(filter: any){
    const filterString = this.generateQueryStringFromObject(applyFilterDateRange(filter || {}));
    return this.http.get(environment.apiUrl+'get/Auditor/FollowUp?' + filterString)
  }

  getResolutionGraphColors(filter: any){
    const filterString = this.generateQueryStringFromObject(filter)
    return this.http.get(environment.apiUrl+'get/resolution-graph-colors?' + filterString)
  }

  getAuditorFollowUpCounts(){
    return this.http.get(environment.apiUrl+'get/auditor/follow/counts')
  }

  getGlobalData(filter: any){
    const filterString = this.generateQueryStringFromObject(applyFilterDateRange(filter || {}))
    return this.http.get(environment.apiUrl+'get/global/data?' + filterString)
  }

  getResRollupChildren(filter: any){
    const filterString = this.generateQueryStringFromObject(applyFilterDateRange(filter || {}))
    return this.http.get(environment.apiUrl+'get/child/resCode/rollups?' + filterString)
  }

  getresCodeSelect(filter: any){
    const filterString = this.generateQueryStringFromObject(filter)
    return this.http.get(environment.apiUrl+'fetch/resCode/select?' + filterString)
  }

  getAdminIdStorageTypes(filter: any){
    const filterString = this.generateQueryStringFromObject(filter)
    return this.http.get(environment.apiUrl+'fetch/adminId/storage?' + filterString)
  }

  getComparisonData(filter: any){
    const filterString = this.generateQueryStringFromObject(applyFilterDateRange(filter || {}))
    return this.http.get(environment.apiUrl+'get/comparison/data?' + filterString)
  }

  fetchAdminID(filter: any){
    const filterString = this.generateQueryStringFromObject(applyFilterDateRange(filter || {}))
    return this.http.get(environment.apiUrl+'fetch/adminId/select?' + filterString)
  }

  fetchAdminName(data: any){
    const filter = this.generateQueryStringFromObject(data);
    return this.http.get(environment.apiUrl+"fetch/adiminName?" + filter)
  }

  getMedicationInsights(data: any) {
    const filter = this.generateQueryStringFromObject(data);
    return this.http.get(environment.apiUrl + 'medication/insights?' + filter);
  }

  getMedSelect(filter: any){
    const filterString = this.generateQueryStringFromObject(filter)
    return this.http.get(environment.apiUrl+'fetch/medGroup/select?' + filterString)
  }

  getMedOfInterest(filter: MedsOfInterestFilter = {}){
    const requestFilter = { ...(filter || {}) };
    const filterString = this.generateQueryStringFromObject(requestFilter);
    const url = filterString
      ? environment.apiUrl + 'meds/of/interest?' + filterString
      : environment.apiUrl + 'meds/of/interest';
    return this.http.get<MedsOfInterestResponse>(url);
  }

  updateAssayTrackable(medGroupName: string, assayTrackable: boolean) {
    return this.http.put(environment.apiUrl + 'assay/trackable', { medGroupName, assayTrackable });
  }

  getMonitoredMedsOfInterest(filter: MedsOfInterestFilter = {}){
    return this.getMedOfInterest({ ...filter, monitor: true });
  }

  getAvailableMedicationGroups(filter: MedsOfInterestFilter = {}) {
    return this.getMedOfInterest({ ...filter, monitor: false });
  }

  enableMedicationGroup(data: any) {
    return this.http.put(environment.apiUrl + 'meds/of/interest', {
      ...data,
      monitor: true
    });
  }

  saveMedicationGroup(data: any) {
    return this.http.put(environment.apiUrl + 'meds/of/interest', data);
  }

  saveItemsMonitorHistory(data: any) {
    return this.http.post(environment.apiUrl + 'items/monitor/history', data);
  }

  getStockArea(filter: StockAreaFilter = {}): Observable<StockAreaApiResponse> {
    const stockAreaType = filter.stockAreaType ?? filter.deviceType;
    const requestFilter: StockAreaFilter = stockAreaType
      ? { ...filter, stockAreaType }
      : filter;

    const filterString = this.generateQueryStringFromObject(requestFilter);
    const querySuffix = filterString ? `?${filterString}` : '';

    return this.http.get<StockAreaApiResponse>(environment.apiUrl + 'stock/area/config' + querySuffix);
  }

  updateStockAreaConfig(
    row: StockAreaConfigUpdateRow,
    assayTrackable: boolean,
    complianceTimeWindow: ComplianceWindow = row?.complianceTimeWindow ?? DEFAULT_COMPLIANCE_WINDOW
  ) {
    const currentUser = this.authService.user || {};
    const userRole = currentUser.role || '';
    const userName = currentUser.fullname || currentUser.email || '';

    if (userRole !== 'DDPD') {
      return throwError(() => new Error('User is not allowed to update stock area configuration.'));
    }

    const payload = {
      ...row,
      assayTrackable,
      complianceTimeWindow,
      userRole,
      updatedBy: userName
    };

    return this.http.put(environment.apiUrl + 'stock/area/config', payload);
  }
}
